const ValidationMessages = {
  required: 'This field cannot be empty',
  notEmpty: 'This field cannot be empty',
  isNumber: 'Only numbers',
  minNumber: 'Minimum value: 1',
  maxNumber: 'This number cannot be over ',
}

export default ValidationMessages
